import {mount} from "svelte";
import App from "./App.svelte";

/** @type {any} */
let app;

const target = document.getElementById("stitch_site");

if (target) {
    app = mount(App, {target});
}

export default app;